<template>
  <div class="waiting-list-form max-w-[600px] mx-auto">
    <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
      <div class="flex items-center mb-4">
        <div class="flex-shrink-0">
          <svg class="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-lg font-medium text-yellow-800">
            Kurs ausgebucht
          </h3>
          <p class="text-sm text-yellow-700">
            Dieser Kurs ist leider ausgebucht. Geben Sie Ihre E-Mail-Adresse ein, um benachrichtigt zu werden, wenn ein Platz frei wird.
          </p>
        </div>
      </div>
    </div>

    <form @submit.prevent="submitForm" class="space-y-6 text-center">
      <div>
        <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
          E-Mail-Adresse *
        </label>
        <input
          id="email"
          v-model="form.email"
          type="email"
          required
          class="input-field max-w-[300px]"
          placeholder="ihre.email@beispiel.de"
        />
      </div>


      <!-- Legal Notice -->
      <div class="bg-gray-50 rounded-lg p-4 mb-4">
        <p class="text-sm text-gray-600 leading-relaxed">
          Mit dem Klick auf "Auf Warteliste setzen" bestätigen Sie, dass Sie unsere 
          <a href="/agb" target="_blank" class="text-mifo-accent hover:underline font-medium">Allgemeinen Geschäftsbedingungen</a> 
          gelesen haben und mit deren Geltung einverstanden sind. Zudem haben Sie unsere 
          <a href="/datenschutz" target="_blank" class="text-mifo-accent hover:underline font-medium">Datenschutzerklärung</a> 
          zur Kenntnis genommen.
        </p>
      </div>


      <div class="flex justify-center">
        <button
          type="submit"
          :disabled="loading"
          class="btn-primary px-6 py-2"
          :class="{ 'opacity-50 cursor-not-allowed': loading }"
        >
          <span v-if="loading">Wird hinzugefügt...</span>
          <span v-else>Auf Warteliste setzen</span>
        </button>
      </div>
    </form>

    <!-- Success Message -->
    <div v-if="success" class="mt-6 bg-green-50 border border-green-200 rounded-lg p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <p class="text-sm font-medium text-green-800">
            Erfolgreich auf Warteliste gesetzt!
          </p>
          <p class="text-sm text-green-700 mt-1">
            Sie werden benachrichtigt, sobald ein Platz frei wird.
          </p>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div v-if="error" class="mt-6 bg-red-50 border border-red-200 rounded-lg p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <p class="text-sm font-medium text-red-800">
            Fehler beim Hinzufügen zur Warteliste
          </p>
          <p class="text-sm text-red-700 mt-1">
            {{ error }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import api from '@/utils/axios'

export default {
  name: 'WaitingListForm',
  props: {
    courseId: {
      type: String,
      required: true
    }
  },
  emits: ['cancel', 'success'],
  setup(props, { emit }) {
    const loading = ref(false)
    const success = ref(false)
    const error = ref('')

    const form = reactive({
      email: ''
    })

    const submitForm = async () => {
      loading.value = true
      error.value = ''

      try {
        const response = await api.post(`/waiting-list/add`, {
          courseId: props.courseId,
          email: form.email
        })

        if (response.data.success) {
          success.value = true
          emit('success', response.data)
        }
      } catch (err) {
        error.value = err.response?.data?.error || 'Ein Fehler ist aufgetreten'
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      loading,
      success,
      error,
      submitForm
    }
  }
}
</script> 